/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesPriceListCategoryResponseDto } from '../../models/sales-price-list-category-response-dto';

export interface PriceListCategoriesControllerFindAllByTenant$Params {

/**
 * Tenant ID
 */
  tenant: string;
}

export function priceListCategoriesControllerFindAllByTenant(http: HttpClient, rootUrl: string, params: PriceListCategoriesControllerFindAllByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesPriceListCategoryResponseDto>>> {
  const rb = new SalesRequestBuilder(rootUrl, priceListCategoriesControllerFindAllByTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<Array<SalesPriceListCategoryResponseDto>>;
    })
  );
}

priceListCategoriesControllerFindAllByTenant.PATH = '/o2-sales/price-list-categories/{tenant}';
